import { detailsSmall, h3, paragraph, paragraphCss } from "@/styles/typography";
import styled from "styled-components";
import { StyledDefaultButtonDark } from "@/components/Buttons/DefaultButtonDark/DefaultButtonDark.style";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 150px;
  flex-wrap: wrap;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0 20px 50px 20px;
  flex-direction: row;
  overflow-x: scroll;
  gap: 20px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-bottom: 50px;
    padding: 0px 16px;
    gap: 16px;
  }
`;

const Paragraph = styled(paragraph)`
  max-width: 620px;
  margin-bottom: 50px;
`;

const CardContainer = styled.div`
  padding: 30px 20px;
  background-color: white;
  height: fit-content;
  width: 450px;
  box-shadow: ${({ theme }) => theme.shadow.primary};

  @media ${({ theme }) => theme.breakpoints.md} {
    min-width: 325px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    min-width: 230px;
    padding: 24px 16px;
  }
`;

const CardWrapper = styled.div`
  padding: 30px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  height: 170px;
  justify-content: space-between;
  &:last-of-type {
    height: 255px;
  }
`;

const CardTitle = styled(h3)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
`;

const CardParagraph = styled(paragraph)`
  &:last-of-type {
    margin-bottom: 20px;
  }
`;

const CardPrice = styled(h3)`
  padding-top: 20px;
`;

const Dash = styled(paragraph)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  font-size: 36px;
`;

const CardSpecWrapper = styled.ul`
  padding: 30px 0;
  max-height: fit-content;
`;

const CardSpecTitle = styled(detailsSmall)`
  text-transform: uppercase;
  margin-bottom: 30px;
`;

const CardSpec = styled.div`
  display: flex;
  margin-bottom: 20px;

  gap: 13px;
  ${paragraphCss}

  img {
    margin-top: 5px;
    width: 16.5px;
    height: 12.75px;
    align-self: flex-start;
  }
`;

const TableWrapper = styled.div`
  font-family: 'Avenir Next';
  width: 80%;
  margin: auto;
  overflow: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
`;

const Th = styled.th`
  text-align: center;
  background-color: #124d60;
  color: #fff;
  padding: 10px;
  border: 1px solid #ddd;
  text-transform: capitalize;
`;

const Td = styled.td<{ hide?: boolean, maxWidth?: boolean }>`
  &:first-of-type, &:nth-child(2)  {
    font-weight: bold;
    text-transform: uppercase;
    font-family: 'Avenir Next Bold';
    text-align: left;
    padding-left: 1.5rem;
    overflow: clip;
  }
  font-size: 0.8rem;
  @media ${({ theme }) => theme.breakpoints.lg} {
    a {
      font-size: 16px;
    }
  }
  @media ${({ theme }) => theme.breakpoints.md} {
    &:first-of-type, &:nth-child(2)  {
      padding-left: 0.5rem;
    }
    a {
      font-size: 14px;
    }
  }
  background-color: ${({ hide }) => hide ? 'red' : ''};
  display: ${({ hide }) => hide ? 'none' : ''};
  max-width: ${({ maxWidth }) => maxWidth ? '13rem' : '8rem'};
  padding: 0.8rem;
  border: 1px solid #ddd;
  text-align: center;
  @media ${({ theme }) => theme.breakpoints.sm} {
    a {
      font-size: 12px;
    }
  }
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const Footnotes = styled(Container)`
  @media ${({ theme }) => theme.breakpoints.lg} {
    flex-direction: column;
  }
`;

const Footnote = styled(paragraph)`
  padding-left: 12px;
  &:first-of-type {
    padding-left: 0;
  }
  font-size: 12px;
  padding-bottom: 6px;
  white-space: nowrap;
`;

const OptionContainer = styled(paragraph)`
  position: relative;
`;

const SmallParagraph = styled.span<{ dash?: boolean}>`
  font-size: 10px;
  position: absolute;
  top: ${({ dash }) => dash ? '-5px' : '-15px'};
  margin-left: ${({ dash }) => dash ? '5px' : ''};
  color: #124d60;
  font-weight: bold;
}
`;

const TableButton = styled(StyledDefaultButtonDark)`
  min-width: 100%;
`;

const S = {
  Container,
  HeadWrapper,
  Wrapper,
  Paragraph,
  CardContainer,
  CardWrapper,
  CardTitle,
  CardParagraph,
  CardPrice,
  CardSpecWrapper,
  CardSpecTitle,
  CardSpec,
   // * Tablestyles
  Table,
  TableWrapper,
  Td,
  Tr, 
  Th,
  Dash,
  Footnotes,
  Footnote,
  OptionContainer,
  SmallParagraph,
  TableButton
};

export default S;
